import { useContext } from "react";
import { BreakdownContext } from "../providers";

const useBreakdown = () => {
  const breakdownContext = useContext(BreakdownContext);

  if (!breakdownContext) {
    throw new Error("useBreakdown must be used within an BreakdownProvider");
  }
  return breakdownContext;
};

export default useBreakdown;
